// extracted by mini-css-extract-plugin
module.exports = {"helperText":"CampaignDescriptionFormItem_helperText__3bJ5E"};